import { render, staticRenderFns } from "./AddNewReseller.vue?vue&type=template&id=bc698b60&scoped=true&"
import script from "./AddNewReseller.vue?vue&type=script&lang=js&"
export * from "./AddNewReseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc698b60",
  null
  
)

export default component.exports